import { useForm } from "react-hook-form";
import RichTextEditor from "../../components/Forms/RichTextEditor";
import MediaUpload from "../../components/Forms/MediaUpload";
import { useEffect, useMemo, useState } from "react";
import { ActionButton } from "../../components/Forms/ActionButton";
import { useGetActiveOrganiser, useGetAllUsers } from "../../queries/user";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useGetChallengeCategoriesList, useGetChallengeList } from "../../queries/challenge";
import { useCreateBlog, useEditBlog, useGetBlogsById } from "../../queries/blog";
import { useLocation, useNavigate } from "react-router-dom";
import ActiveStatus from "../../components/Common/ActiveStatus";
import MediaLibrary from "../MediaLibrary/MediaLibrary";
import MultiMediaUploadSection from "../../components/Forms/MultiMediaUploadSection";
import Dropdown from "../../components/Forms/Dropdown";
import NewDropdown from "../../components/Forms/NewDropdown";
import Chip from "../../components/Chip";
import { useDeleteEcoActivityComment, useGetEcoActivityUserComments } from "../../queries/facts";
import TanStackTable from "../../components/TanStackTable";
import { FaTrash } from "react-icons/fa";
import { createColumnHelper } from "@tanstack/react-table";
import { useGetProductsList } from "../../queries/products";

const CreateBlog = () => {

    const navigate = useNavigate();

    const { state } = useLocation();
    const blogId = state?.blogId;

    const [coverImage, setCoverImage] = useState(null);
    const [featured, setFeatured] = useState([]);
    const [gallery, setGallery] = useState([]);
    const [active, setActive] = useState(false);
    const [shareToHomeScreen, setShareToHomeScreen] = useState(false);

    const { data: challengeCategoryList, isLoading: isChallengeCategoryPending } = useGetChallengeCategoriesList();
    const { data: blogData, isLoading: isBlogDataPending } = useGetBlogsById(blogId);
    console.log('blog details pending ', isBlogDataPending);

    const commentsQueryData = blogData?._id ? { id: blogData._id, refType: "Blog" } : null;
    const { data: likes, isLoading: isLikesPending, refetch } = useGetEcoActivityUserComments(commentsQueryData);
    const { mutateAsync: deleteComment, isLoading: isDeletingComment } = useDeleteEcoActivityComment();

    const deleteCommentHandler = async (commentId) => {
        const confirm = window.confirm("Are you sure you want to delete this comment?");
        if (!confirm) return;
        await deleteComment({ commentId: commentId, refId: blogData?._id, refType: "Blog" }, {
            onSuccess: () => {
                toast.success("Comment deleted successfully");
                refetch();
            },
            onError: (error) => {
                toast.error("Error deleting comment");
                console.error("Error deleting comment:", error);
            }
        });
    }

    const columnHelper = createColumnHelper();

    const columns = useMemo(() => [
        columnHelper.display({
            id: 'srno',
            header: 'Sr No.',
            cell: info => info.row.index + 1,
            size: 80, // Fixed narrow width
        }),
        columnHelper.accessor('username', {
            header: 'User Name',
            cell: info => (
                <div className="line-clamp-1 flex items-center gap-2">
                    <img src={info.row.original?.createdBy?.profilepic} alt="-" className="size-5 rounded-full" />
                    {info.row.original?.createdBy?.username || 'N/A'}
                </div>
            ),
            size: 150, // Fixed width
        }),
        columnHelper.accessor('description', {
            header: 'Comment',
            cell: info => (
                <div className="line-clamp-1 w-full">
                    {info.getValue() || '-'}
                </div>
            ),
            size: 'auto', // Will take up remaining space
            minSize: 200, // Minimum width
        }),
        {
            accessorKey: 'createdAt',
            header: 'Date & Time',
            align: 'center',
            meta: {
                filterVariant: 'date',
            },
            cell: ({ getValue }) => {
                const value = getValue();
                return value ? value.toRegularDateTime() : '-';
            },
            size: 120, // Fixed width
        },
        columnHelper.accessor('actions', {
            header: 'Actions',
            align: 'center',
            enableColumnFilter: false,
            cell: info => {
                return (
                    <div className='flex items-center justify-center'>
                        <button
                            className="rounded p-1.5 bg-[rgba(199,52,52,0.1)] hover:bg-[rgba(199,52,52,0.2)] mx-1 min-h-7"
                            onClick={() => {
                                deleteCommentHandler(info.row.original._id);
                            }}
                        >
                            <FaTrash className="fill-chipRed" />
                        </button>
                    </div>
                )
            },
            size: 80, // Fixed width
        }),
    ], [navigate]);

    // const { data: users, isPending: isUserPending } = useGetAllUsers(toast);
    const { data: challenges, isLoading: isChallengePending } = useGetChallengeList();
    const { data: productsList, isLoading: isProductsLoading } = useGetProductsList();

    const { mutateAsync, isPending: isCreatingBlog } = useCreateBlog();

    const { mutateAsync: editBlog, isPending: isEditingBlog } = useEditBlog(blogId);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        watch,
        getValues,
        reset,
    } = useForm({
        defaultValues: {
            title: blogData ? blogData.title : "",
            category: blogData ? blogData.category : "",
            blogType: blogData ? blogData.blogType : "System Generated",
            startDate: blogData ? blogData.startDate : "",
            endDate: blogData ? blogData.endDate : "",
            description: blogData ? blogData.description : "",
            connectedChallenge: blogData ? blogData.connectedChallenge : "",
            blogCreator: blogData?.blogCreator || "",
            attachedProduct: blogData?.attachedProduct || ""
        }
    });

    const blogType = watch("blogType");

    // your user list (for User Created case)
    const { data: usersData, isLoading: isUserListLoading } = useGetAllUsers(toast);
    const users = Array.isArray(usersData) ? usersData : (usersData?.users || []);
    // your company/NGO list (for Sponsor case)
    const { data: organiserList = [] } = useGetActiveOrganiser();

    // const onSubmit = (data) => {
    //     let organiser = {};
    //     organiserList.filter(organizer => {
    //         if (organizer._id === data.eventOrganiser) {
    //             const orgType = organizer.organiserType;
    //             if (orgType === 'NGO') {
    //                 organiser.createdByNgo = organizer._id;
    //             } else if (orgType === 'Company') {
    //                 organiser.createdByCompany = organizer._id;
    //             }
    //         }
    //     });
    //     console.log(organiser);
    //     console.log({ ...data, coverImage, featured, gallery, active, shareToHomeScreen, ...organiser });
    //     // if (blogId) {
    //     //     editBlog({
    //     //         ...data,
    //     //         status: active ? "active" : "inactive",
    //     //         coverImage: [coverImage],
    //     //     },
    //     //         {
    //     //             onSuccess: () => {
    //     //                 toast.success("Blog updated successfully");
    //     //                 reset();
    //     //                 setCoverImage(null);
    //     //                 setTimeout(() => {
    //     //                     navigate('/blogs/blog-list');
    //     //                 }, 2000);
    //     //             },
    //     //             onError: (err) => {
    //     //                 console.error(err);
    //     //                 toast.error("An error occurred while creating the blog!");
    //     //             }
    //     //         }
    //     //     );
    //     // } else {
    //     //     mutateAsync({
    //     //         ...data,
    //     //         status: active ? "active" : "inactive",
    //     //         coverImage: coverImage ? coverImage[0]?.startsWith('https') ? coverImage : [coverImage] : [],
    //     //     },
    //     //         {
    //     //             onSuccess: () => {
    //     //                 toast.success("Blog created successfully");
    //     //                 reset();
    //     //                 setCoverImage(null);
    //     //                 setTimeout(() => {
    //     //                     navigate('/blogs/blog-list');
    //     //                 }, 2000);
    //     //             },
    //     //             onError: (err) => {
    //     //                 console.error(err);
    //     //                 toast.error("An error occurred while creating the blog!");
    //     //             }
    //     //         }
    //     //     );
    //     // }
    // };


    const onSubmit = (data) => {

        // Find the selected organiser entry
        const selected = organiserList.find(o => o._id === data.blogCreator);

        // Build payload in the exact order your API expects
        const payload = {
            active: active,
            title: data.title,
            description: data.description,
            overview: data.overview,
            category: data.category,
            connectedChallenge: data.connectedChallenge,
            attachedProduct: data.attachedProduct,
            blogType: data.blogType,

            // status & flags
            status: blogData?.status || "",
            atHome: shareToHomeScreen,

            startDate: data.startDate,
            endDate: data.endDate,

            // creator IDs
            createdByUser: blogType === 'User Created' ? data.blogCreator : null,
            createdByAdmin: null,
            createdByNgo: selected?.organiserType === 'NGO' ? data.blogCreator : null,
            createdByCompany: selected?.organiserType === 'Company' ? data.blogCreator : null,

            // and finally the type string
            createdByUserType:
                blogType === 'System Generated' ? 'admin' :
                    blogType === 'User Created' ? 'user' :
                        blogType === 'Sponsored' ? selected.organiserType.toLowerCase() :
                            'admin',

            // Image metadata for updates
            fileId: blogData?.fileId || blogData?.coverImageId,
            fileVersion: blogData?.fileVersion || blogData?.coverImageVersion,
        };

        // If user didn't change the image, preserve the existing URL
        if (coverImage && typeof coverImage === 'string') {
            payload.file = coverImage;
        }

        // Prepare file objects for Image API V2
        const coverImageFile = coverImage instanceof File ? coverImage : null;
        const featuredImagesFiles = featured.filter(img => img instanceof File);
        const galleryImagesFiles = gallery.filter(img => img instanceof File);

        // Preserve existing image URLs (strings) so they aren't lost on save
        payload.featuredImages = featured.filter(img => typeof img === 'string');
        payload.imageGallery = gallery.filter(img => typeof img === 'string');

        // console.log(payload);
        toast.loading('Processing your request...');
        if (blogId) {
            editBlog({
                data: payload,
                coverImage: coverImageFile,
                featuredImages: featuredImagesFiles,
                galleryImages: galleryImagesFiles
            },
                {
                    onSuccess: () => {
                        toast.success("Blog updated successfully");
                        reset();
                        setCoverImage(null);
                        setTimeout(() => {
                            if (blogType === 'user') {
                                navigate('/blogs/blog-list-user');
                            }
                            else {
                                navigate('/blogs/blog-list-admin');
                            }
                        }, 2000);
                    },
                    onError: (err) => {
                        console.error(err);
                        toast.error("An error occurred while creating the blog!");
                    }
                }
            );
        } else {
            mutateAsync({
                data: payload,
                coverImage: coverImageFile,
                featuredImages: featuredImagesFiles,
                galleryImages: galleryImagesFiles
            },
                {
                    onSuccess: () => {
                        toast.success("Blog created successfully");
                        reset();
                        setCoverImage(null);
                        setTimeout(() => {
                            if (blogType === 'user') {
                                navigate('/blogs/blog-list-user');
                            }
                            else {
                                navigate('/blogs/blog-list-admin');
                            }
                        }, 2000);
                    },
                    onError: (err) => {
                        console.error(err);
                        toast.error("An error occurred while creating the blog!");
                    }
                }
            );
        }
    };

    const renderBlogCreator = (item) => {
        if (item?.createdByUser) {
            return item?.createdByUser?._id || null
        }
        else if (item?.createdByAdmin) {
            return "Admin"
        }
        else if (item?.createdByNgo) {
            return item?.createdByNgo?._id || null
        }
        else if (item?.createdByCompany) {
            return item?.createdByCompany?._id || null
        }
    }

    useEffect(() => {
        setValue('blogType', 'System Generated');
        setTimeout(() => {
            if (blogData && challenges) {
                console.log('inside set timeout: ', blogData);
                setValue("title", blogData?.title);
                setValue("category", blogData?.category?._id);
                setValue("startDate", (blogData?.startDate && blogData?.startDate.split("T")[0]) || "");
                setValue("endDate", (blogData?.endDate && blogData?.endDate.split("T")[0]) || "");
                setValue("description", blogData?.description);
                setValue("connectedChallenge", blogData?.connectedChallenge?._id);
                setValue("blogType", blogData?.blogType);
                setValue("blogCreator", renderBlogCreator(blogData));
                setValue("attachedProduct", blogData?.attachedProduct || "");
                setShareToHomeScreen(blogData?.atHome);
                setCoverImage(blogData?.coverImage?.[0]);
                setFeatured(blogData?.featuredImages || []);
                setGallery(blogData?.imageGallery || []);
                setActive(blogData?.active);
                // if (blogData?.status !== "pending" && blogData?.status !== 'rejected') {
                //     setActive(false);
                // }
            }
        }, 500);
        console.log('inside useEffect: ', blogData);
    }, [blogData, isBlogDataPending, isChallengePending]);

    if (isBlogDataPending || isChallengePending || isUserListLoading || isChallengeCategoryPending || isLikesPending || isProductsLoading) {
        return <div className="flex justify-center items-center h-screen">
            <p className="text-lg font-semibold">Loading...</p>
        </div>
    }

    return (
        <>
            <form className="flex flex-col w-full font-semibold" onSubmit={handleSubmit(onSubmit)}>
                {
                    blogData?.status !== "pending" && blogData?.status !== 'rejected' && (
                        <div className="flex items-center justify-end gap-3">
                            <ActiveStatus
                                active={active}
                                setActive={setActive}
                                isCreateForm={true}
                            // disabled={(blogData?.status !== "pending" && blogData?.status !== 'rejected')}
                            />
                            <ActiveStatus
                                active={shareToHomeScreen}
                                setActive={setShareToHomeScreen}
                                isCreateForm={true}
                                label={'Home Screen'}
                                innerActiveText="Yes"
                                innerInactiveText="No"
                            />
                        </div>
                    )
                }
                {
                    (blogData?.status === "pending" || blogData?.status === 'rejected') && (
                        <div
                            className="text-base border px-4 py-2 rounded flex items-center gap-2 mb-3"
                            role="alert"
                            style={{
                                backgroundColor: '#29abe233',
                                color: '#146c91',
                                borderColor: '#29abe2',
                            }}
                        >
                            This is a user-generated blog and you can show the blog in the app only after you approve it.
                        </div>
                    )
                }
                <section className="flex flex-col justify-center px-5 pt-2 py-9 gap-3  w-full bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)]">
                    <div className="flex items-center justify-between">
                        <p className="text-base font-bold mt-3">Blog Information</p>
                        {
                            (blogData?.status === "pending" || blogData?.status === 'rejected') && (
                                <Chip value={blogData?.status} color="red" />
                            )
                        }
                    </div>
                    <div className="flex gap-3">
                        <div className="flex flex-col w-full gap-4">
                            {/* Blog Title */}
                            <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-1.5">
                                <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Blog Title</label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <input
                                        type="text"
                                        placeholder="Blog Title"
                                        {...register("title", { required: "Title is required" })}
                                        className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors.title ? "border-red-500" : ""}`}
                                    />
                                </div>
                                {errors.title && <p className="text-red text-sm">{errors.title.message}</p>}
                            </div>
                            <div className="flex items-center gap-3">
                                {/* Category */}
                                <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full">
                                    <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Blog Category</label>
                                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                        <select
                                            {...register("category", { required: "Blog Category is required" })}
                                            className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors.category ? "border-red-500" : ""}`}
                                        >
                                            <option value="">Select Blog Category</option>
                                            {challengeCategoryList?.map((category) => (
                                                <option key={category?._id} value={category?._id}>
                                                    {category?.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {errors.category && <p className="text-red text-sm">{errors.category.message}</p>}
                                </div>
                                {/* Blog Type */}
                                <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full">
                                    <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Blog Type</label>
                                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                        <select
                                            className="flex-1 select2 shrink self-stretch my-auto basis-0 px-4 py-2.5 outline-primary rounded-md capitalize text-base"
                                            {...register("blogType", { required: "Blog Type is required" })}
                                        >
                                            <option value="">Choose Blog Type</option>
                                            <option value="System Generated">System Generated</option>
                                            {
                                                blogData?.blogType === "User Created" && (
                                                    <option value="User Created">User Created</option>
                                                )
                                            }
                                            <option value="Sponsored">Sponsored</option>
                                        </select>
                                    </div>
                                    {errors.blogType && <p className="text-red text-sm">{errors.blogType.message}</p>}
                                </div>
                            </div>
                            <div className="flex items-center gap-3">
                                <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full">
                                    <label className="text-base text-gray-900 font-semibold capitalize">
                                        Blog Creator
                                    </label>
                                    <div
                                        className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400"
                                    >
                                        {blogType === "System Generated" && (
                                            <input
                                                type="text"
                                                value="admin"
                                                disabled
                                                className="flex-1 px-4 py-2.5 rounded-md text-base bg-gray-100 cursor-not-allowed"
                                            />
                                        )}

                                        {blogType === "Sponsored" && (
                                            <Dropdown
                                                register={register}
                                                name="blogCreator"
                                                requiredMessage={false}
                                                dataList={organiserList}
                                                placeholder="Select Sponsor"
                                                className="flex-1"
                                            />
                                        )}

                                        {blogType === "User Created" && (
                                            <select
                                                {...register("blogCreator", { required: true })}
                                                // disabled
                                                className="flex-1 px-4 py-2.5 rounded-md text-base cursor-not-allowed bg-gray-100"
                                            >
                                                <option value="">Select User</option>
                                                {users.map((u) => (
                                                    <option key={u._id} value={u._id}>
                                                        {u.username}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    </div>
                                    {errors.blogCreator && (
                                        <p className="text-red text-sm">{errors.blogCreator.message}</p>
                                    )}
                                </div>
                            </div>
                            <div></div>
                            {/* Blog Status */}
                            {/* <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full">
                                <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Blog Status</label>
                                <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                    <select
                                        className="flex-1 select2 shrink self-stretch my-auto basis-0 px-4 py-2.5 outline-primary rounded-md capitalize text-base"
                                        {...register("blogStatus", { required: "Blog Status is required" })}
                                    >
                                        <option value="">Choose Blog Status</option>
                                        <option value="draft">Draft</option>
                                        <option value="published">Published</option>
                                        <option value="unpublished">Unpublished</option>
                                        <option value="accepted">Accepted</option>
                                        <option value="not-accepted">Not-Accepted</option>
                                    </select>
                                </div>
                                {errors.blogStatus && <p className="text-red text-sm">{errors.blogStatus.message}</p>}
                            </div> */}
                            {/* User */}
                            {/* <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full">
                                    <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">User</label>
                                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                        <select
                                            className="flex-1 select2 shrink self-stretch my-auto basis-0 px-4 py-2.5 outline-primary rounded-md capitalize text-base"
                                            {...register("userId", { required: "User is required" })}
                                        >
                                            <option value="">Choose User</option>
                                            {users.map((user) => (
                                                <option key={user._id} value={user._id}>
                                                    {user.username}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {errors.userId && <p className="text-red text-sm">{errors.userId.message}</p>}
                                </div> */}
                            <div className="flex flex-1 grow shrink-0 basis-0 w-full gap-3">
                                {/* Start Date */}
                                <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full">
                                    <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Start Date</label>
                                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                        <input
                                            type="date"
                                            placeholder="Start Date"
                                            {...register("startDate", { required: false })}
                                            className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors.title ? "border-red-500" : ""}`}
                                        />
                                    </div>
                                    {errors.startDate && <p className="text-red text-sm">{errors.startDate.message}</p>}
                                </div>
                                {/* End Date */}
                                <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full">
                                    <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">End Date</label>
                                    <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                        <input
                                            type="date"
                                            placeholder="End Date"
                                            {...register("endDate", { required: false })}
                                            className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors.title ? "border-red-500" : ""}`}
                                        />
                                    </div>
                                    {errors.endDate && <p className="text-red text-sm">{errors.endDate.message}</p>}
                                </div>
                            </div>
                        </div>
                        {/* Blog Cover Image */}
                        <div className="mt-0">
                            <MediaUpload
                                clearMedia={false}
                                label={"Thumbnail"}
                                existingImage={coverImage}
                                setImageUpload={setCoverImage}
                                stateImage={coverImage}
                                setStateImageUpload={setCoverImage}
                                useFileObject={true}
                            />
                        </div>
                    </div>

                    {/* Blog Description */}
                    <div className="mt-2">
                        <RichTextEditor
                            label="Blog Description"
                            placeholder="Write your blog content here..."
                            name="description"
                            value={getValues("description")}
                            onChange={(value) => setValue("description", value)}
                            error={errors.content}
                        // required={true}
                        />
                    </div>

                    {/* Share to home screen */}
                    {/* <div className="flex flex-1 items-center justify-start shrink-0 basis-0 w-full my-2">
                        <label className="gap-1 text-base text-gray-900 font-semibold capitalize">Share to Home Screen</label>
                        <input
                            type="checkbox"
                            className="h-4 w-4 text-primary border-gray-300 rounded focus:ring-primary ml-2"
                            {...register("shareToHomeScreen", { required: false })}
                            checked={shareToHomeScreen}
                            onChange={(e) => setShareToHomeScreen(e.target.checked)}
                        />
                    </div> */}

                    {/* Connected Challenge */}
                    <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full">
                        <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Connected Challenge</label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <select
                                className="flex-1 select2 shrink self-stretch my-auto basis-0 px-4 py-2.5 outline-primary rounded-md capitalize text-base"
                                {...register("connectedChallenge", { required: false })}
                            >
                                <option value="">Choose Connected Challenge</option>
                                {
                                    challenges.map((challenge) => (
                                        <option key={challenge._id} value={challenge._id}>
                                            {challenge.name}
                                        </option>
                                    ))
                                }
                            </select>
                        </div>
                        {errors.connectedChallenge && <p className="text-red text-sm">{errors.connectedChallenge.message}</p>}
                    </div>

                    {/* Attach Product */}
                    <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full">
                        <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Attach Product</label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <NewDropdown
                                register={register}
                                name="attachedProduct"
                                onChange={(selectedOption) => setValue("attachedProduct", selectedOption.value)}
                                requiredMessage={false}
                                dataList={productsList}
                                placeholder="Select a product"
                                value={watch("attachedProduct")}
                                allowMultiple={false}
                                disabled={false}
                            />
                        </div>
                        {errors.attachedProduct && <p className="text-red text-sm">{errors.attachedProduct.message}</p>}
                    </div>

                    <div className="flex flex-wrap md:flex-nowrap gap-5 mt-2">
                        {/* <MultiMediaUploadSection
                            title="Featured Images"
                            files={featured}
                            setFiles={setFeatured}
                        /> */}
                        <MultiMediaUploadSection
                            title="Image Gallery"
                            files={gallery}
                            setFiles={setGallery}
                        />
                    </div>

                    {/* Points */}
                    {/* <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-3">
                        <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Points</label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <input
                                type="text"
                                placeholder="Points"
                                {...register("points", { required: "Points is required" })}
                                className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${errors.title ? "border-red-500" : ""}`}
                            />
                        </div>
                        {errors.points && <p className="text-red text-sm">{errors.points.message}</p>}
                    </div> */}

                    {/* Sponsor */}
                    {/* <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-3">
                        <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Sponsor</label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <select
                                className="flex-1 select2 shrink self-stretch my-auto basis-0 px-4 py-2.5 outline-primary rounded-md capitalize text-base"
                                {...register("sponsor", { required: "Sponsor is required" })}
                            >
                                <option value="">Choose Sponsor</option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                            </select>
                        </div>
                        {errors.title && <p className="text-red text-sm">{errors.sponsor.message}</p>}
                    </div> */}

                    <div className="mt-10 flex gap-5 items-center justify-between">
                        <ActionButton
                            variant="reset"
                            text="Reset"
                            handleSubmit={() => {
                                reset();
                                setCoverImage(null);
                                setFeatured([]);
                                setGallery([]);
                                setActive(true);
                                setShareToHomeScreen(false);
                            }}
                        />
                        <div className="flex items-center gap-3">
                            <ActionButton
                                variant="cancel"
                                text="Cancel"
                                handleSubmit={() => {
                                    if (blogData?.status === "approve" || blogData?.status === 'active' || blogData?.status === 'inactive') {
                                        navigate('/blogs/blog-list-admin');
                                    } else {
                                        navigate('/blogs/blog-list-user');
                                    }
                                }}
                            />
                            <ActionButton
                                variant="submit"
                                text="Save"
                                handleSubmit={() => { }}
                                disabled={isCreatingBlog || isEditingBlog}
                            />
                        </div>
                    </div>

                </section>
                <ToastContainer
                    position="top-right"
                />
            </form>

            {
                (blogId && blogData?.active) && (
                    <div className="flex flex-col p-5 w-full bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] mt-5">
                        <h2 className="font-bold text-base mb-4">Blog User Comments</h2>
                        <TanStackTable
                            data={likes}
                            columns={columns}
                            enablePagination={true}
                        />
                    </div>
                )
            }
        </>
    );
}

export default CreateBlog;